import React from 'react';
import { Redirect } from 'react-router-dom';

import { useQuery } from '@apollo/client';
import { GET_INFOUSER } from '@betwixt/common/graphql/user.js';

const NoMatch = () => {
  const { data } = useQuery(GET_INFOUSER);
  const User = data?.User;

  return (
    <div>
      {User && User.modulesActived.length ? (
        <Redirect to={{ pathname: `/${User.modulesActived[0].routes.my.path}` }} />
      ) : (
        <Redirect to={{ pathname: '/login' }} />
      )}
    </div>
  );
};

export default NoMatch;
